import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "lorcharacter",
  inputs: [
    {
      name: "name",
      label: "Name",
      placeholder: "Akshay",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "position",
      label: "Position",
      placeholder: "Software Developer",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 150,
    },
    {
      name: "time_period",
      label: "Time Period",
      placeholder: "1 year",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "key_qualities",
      label: "Key Qualities",
      placeholder: "Dedication, Responsible, Punctual",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 200,
    },
  ],
};

export default formFields;
